import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import clsx from 'clsx';

import TreePanel from './TreePanel';
import InformationPanel from './InformationPanel';
import ActionPanel from './ActionPanel';
import DataPanel from './DataPanel';
import SiteDataInsert from './SiteDataInsert';
import EquipmentItemDataInsert from './EquipmentItemDataInsert';
import SystemItemDataInsert from './SystemItemDataInsert';
import ClientDataInsert from './ClientDataInsert';

import CreateAreaModal from '../Modals/CreateAreaModal';
import CreateAreaEquipmentModal from '../Modals/CreateAreaEquipmentModal';
import CreateCampusSitesModal from '../Modals/CreateCampusSitesModal';
import CreateCampusModal from '../Modals/CreateCampusModal';
import CreateClientModal from '../Modals/CreateClientModal';
import CreateContactModal from '../Modals/CreateContactModal';
import CreateEquipmentModal from '../Modals/CreateEquipmentModal';
import CreateEquipmentAreaModal from '../Modals/CreateEquipmentAreaModal';
import CreateEquipmentSystemModal from '../Modals/CreateEquipmentSystemModal';
import CreateClientLinkModal from '../Modals/CreateClientLinkModal';
import CreateLinkModal from '../Modals/CreateLinkModal';
import CreateContactLinkModal from '../Modals/CreateContactLinkModal';
import CreateSensorModal from '../Modals/CreateSensorModal';
import CreateSiteModal from '../Modals/CreateSiteModal';
import CreateSystemModal from '../Modals/CreateSystemModal';
import CreateSystemEquipmentModal from '../Modals/CreateSystemEquipmentModal';

import DeleteAreaModal from '../Modals/DeleteAreaModal';
import DeleteCampusModal from '../Modals/DeleteCampusModal';
import DeleteCampusSiteModal from '../Modals/DeleteCampusSiteModal';
import DeleteContactModal from '../Modals/DeleteContactModal';
import DeleteLinkModal from '../Modals/DeleteLinkModal';
import DeleteClientModal from '../Modals/DeleteClientModal';
import DeleteEquipmentModal from '../Modals/DeleteEquipmentModal';
import DeleteSensorModal from '../Modals/DeleteSensorModal';
import DeleteEquipmentEntityModal from '../Modals/DeleteEquipmentEntityModal';
import DeleteSiteModal from '../Modals/DeleteSiteModal';
import DeleteSystemModal from '../Modals/DeleteSystemModal';
import DeleteSystemEntityModal from '../Modals/DeleteSystemEntityModal';

import EditAreaModal from '../Modals/EditAreaModal';
import EditCampusModal from '../Modals/EditCampusModal';
import EditClientModal from '../Modals/EditClientModal';
import EditContactModal from '../Modals/EditContactModal';
import EditEquipmentModal from '../Modals/EditEquipmentModal';
import EditSensorModal from '../Modals/EditSensorModal';
import EditSiteModal from '../Modals/EditSiteModal';
import EditSystemModal from '../Modals/EditSystemModal';
import PreviewSensorDataModal from '../Modals/PreviewSensorDataModal';
import WeatherDataModal from '../Modals/WeatherDataModal';

import * as ArchitectActions from '../../actions/architectActions';
import * as CoreActions from '../../actions/coreActions';
import * as LookupActions from '../../actions/lookupActions';
import * as WizardActions from '../../actions/wizardActions';
import { fetchErpAgents } from '../../actions/erpAgentActions';
import { fetchEquipmentTypesLookup } from '../../actions/lookupActions';
import { fetchSensorData, clearSensorData } from '../../actions/sensorDataActions';
import { fetchSensorTypes } from '../../actions/sensorTypeActions';
import { fetchSystemTypes } from '../../actions/systemTypeActions';

import classes from './InformationPage.module.css';

class InformationPage extends Component {
    state = {
        companyId:                      '',
        createAreaModalOpen:            false,
        createAreaEquipmentOpen:        false,
        createCampusSitesModalOpen:     false,
        createCampusModalOpen:          false,
        createClientLinkModalOpen:      false,
        createLinkModalOpen:            false,
        createClientModalOpen:          false,
        createContactModalOpen:         false,
        createContactLinkModalOpen:     false,
        createEquipmentModalOpen:       false,
        createEquipmentAreaModalOpen:   false,
        createEquipmentSystemModalOpen: false,
        createSensorModalOpen:          false,
        createSiteModalOpen:            false,
        createSystemModalOpen:          false,
        createSystemEquipmentModalOpen: false,
        deleteAreaModalOpen:            false,
        deleteCampusModalOpen:          false,
        deleteCampusSiteModalOpen:      false,
        deleteContactModalOpen:         false,
        deleteClientModalOpen:          false,
        deleteEquipmentModalOpen:       false,
        deleteLinkModalOpen:            false,
        deleteSensorModalOpen:          false,
        deleteEquipmentEntityModalOpen: false,
        deleteSiteModalOpen:            false,
        deleteSystemModalOpen:          false,
        deleteSystemEntityModalOpen:    false,
        editAreaModalOpen:              false,
        editCampusModalOpen:            false,
        editClientModalOpen:            false,
        editContactModalOpen:           false,
        editEquipmentModalOpen:         false,
        editSensorModalOpen:            false,
        editSiteModalOpen:              false,
        editSystemModalOpen:            false,
        isTreePanelCollapsed:           false,
        previewSensorDataModalOpen:     false,
        weatherDataModalOpen:           false
    }

    async componentDidMount() {
        const {
            companyInfo,
            fetchBuildingTypes,
            fetchBusinessTypes,
            fetchEquipmentManufacturers,
            fetchEquipmentTypesLookup,
            fetchErpAgents,
            fetchErpAgentConfigurations,
            fetchFuelTypes,
            fetchRawUnits,
            fetchSensorTypes,
            fetchSystemTypesLookup,
            setProgressBarLoading,
            setTreeType
        } = this.props;

        setTreeType('architect');

        this.setState({ companyId: companyInfo.companyId });

        setProgressBarLoading(true);
        Promise.all([
            fetchBuildingTypes(),
            fetchBusinessTypes(),
            fetchEquipmentManufacturers(),
            fetchEquipmentTypesLookup(),
            fetchRawUnits(),
            fetchFuelTypes(),
            fetchSensorTypes(),
            fetchSystemTypesLookup(),
            fetchErpAgents(),
            fetchErpAgentConfigurations()
        ].map(p => p.catch(err => err))).then(() => {
            setProgressBarLoading(false);
            this.setState({ companyId: companyInfo.companyId });
        });

    }

    componentDidUpdate(prevProps) {
        const { fetchErpAgents, fetchErpAgentConfigurations, setProgressBarLoading } = this.props;
        const { companyInfo } = prevProps;

        if (this.state.companyId && companyInfo.companyId !== this.state.companyId) {
            setProgressBarLoading(true);
            Promise.all([
                fetchErpAgents(),
                fetchErpAgentConfigurations()
            ].map(p => p.catch(err => err))).then(() => {
                setProgressBarLoading(false);
            });

            this.setState({ companyId: companyInfo.companyId });
        }
    }

    handleIsTreePanelCollapsed = () => {
        this.setState(state => ({
            isTreePanelCollapsed: !this.state.isTreePanelCollapsed
        }));
    }

    handleToggleCreateAreaModal = toggleState => {
        this.setState(state => ({
            createAreaModalOpen: toggleState
        }));
    }

    handleToggleCreateAreaEquipmentModal = toggleState => {
        this.setState(state => ({
            createAreaEquipmentOpen: toggleState
        }));
    }

    handleToggleCreateCampusSitesModal = toggleState => {
        this.setState(state => ({
            createCampusSitesModalOpen: toggleState
        }));
    }

    handleToggleCreateCampusModal = toggleState => {
        this.setState(state => ({
            createCampusModalOpen: toggleState
        }));
    }

    handleToggleCreateClientModal = toggleState => {
        this.setState(state => ({
            createClientModalOpen: toggleState
        }));
    }

    handleToggleCreateContactModal = toggleState => {
        this.setState(state => ({
            createContactModalOpen: toggleState
        }));
    }

    handleToggleCreateEquipmentModal = toggleState => {
        this.setState(state => ({
            createEquipmentModalOpen: toggleState
        }));
    }

    handleToggleCreateEquipmentAreaModal = toggleState => {
        this.setState(state => ({
            createEquipmentAreaModalOpen: toggleState
        }));
    }

    handleToggleCreateEquipmentSystemModal = toggleState => {
        this.setState(state => ({
            createEquipmentSystemModalOpen: toggleState
        }));
    }

    handleToggleCreateClientLinkModal = toggleState => {
        this.setState(state => ({
            createClientLinkModalOpen: toggleState
        }));
    }

    handleToggleCreateLinkModal = toggleState => {
        this.setState(state => ({
            createLinkModalOpen: toggleState
        }));
    }

    handleToggleCreateContactLinkModal = toggleState => {
        this.setState(state => ({
            createContactLinkModalOpen: toggleState
        }));
    }

    handleToggleCreateSensorModal = toggleState => {
        this.setState(state => ({
            createSensorModalOpen: toggleState
        }));
    }

    handleToggleCreateSiteModal = toggleState => {
        this.setState(state => ({
            createSiteModalOpen: toggleState
        }));
    }

    handleToggleCreateSystemModal = toggleState => {
        this.setState(state => ({
            createSystemModalOpen: toggleState
        }));
    }

    handleToggleCreateSystemEquipmentModal = toggleState => {
        this.setState(state => ({
            createSystemEquipmentModalOpen: toggleState
        }));
    }

    handleToggleDeleteAreaModal = togglestate => {
        this.setState(state => ({
            deleteAreaModalOpen: togglestate
        }));
    }

    handleToggleDeleteCampusModal = toggleState => {
        this.setState(state => ({
            deleteCampusModalOpen: toggleState
        }));
    }

    handleToggleDeleteClientModal = toggleState => {
        this.setState(state => ({
            deleteClientModalOpen: toggleState
        }));
    }

    handleToggleDeleteCampusSiteModal = toggleState => {
        this.setState(state => ({
            deleteCampusSiteModalOpen: toggleState
        }));
    }

    handleToggleDeleteContactModal = toggleState => {
        this.setState(state => ({
            deleteContactModalOpen: toggleState
        }));
    }

    handleToggleDeleteEquipmentModal = toggleState => {
        this.setState(state => ({
            deleteEquipmentModalOpen: toggleState
        }));
    }

    handleToggleDeleteLinkModal = toggleState => {
        this.setState(state => ({
            deleteLinkModalOpen: toggleState
        }));
    }

    handleToggleDeleteSensorModal = toggleState => {
        this.setState(state => ({
            deleteSensorModalOpen: toggleState
        }));
    }

    handleToggleDeleteEquipmentEntityModal = toggleState => {
        this.setState(state => ({
            deleteEquipmentEntityModalOpen: toggleState
        }));
    }

    handleToggleDeleteSiteModal = toggleState => {
        this.setState(state => ({
            deleteSiteModalOpen: toggleState
        }));
    }

    handleToggleDeleteSystemModal = toggleState => {
        this.setState(state => ({
            deleteSystemModalOpen: toggleState
        }));
    }

    handleToggleDeleteSystemEntityModal = toggleState => {
        this.setState(state => ({
            deleteSystemEntityModalOpen: toggleState
        }));
    }

    handleToggleEditAreaModal = toggleState => {
        this.setState(state => ({
            editAreaModalOpen: toggleState
        }));
    }

    handleToggleEditCampusModal = toggleState => {
        this.setState(state => ({
            editCampusModalOpen: toggleState
        }));
    }

    handleToggleEditClientModal = toggleState => {
        this.setState(state => ({
            editClientModalOpen: toggleState
        }));
    }

    handleToggleEditContactModal = toggleState => {
        this.setState(state => ({
            editContactModalOpen: toggleState
        }));
    }

    handleToggleEditEquipmentModal = toggleState => {
        this.setState(state => ({
            editEquipmentModalOpen: toggleState
        }));
    }

    handleToggleEditSensorModal = toggleState => {
        this.setState(state => ({
            editSensorModalOpen: toggleState
        }));
    }

    handleToggleEditSiteModal = toggleState => {
        this.setState(state => ({
            editSiteModalOpen: toggleState
        }));
    }

    handleToggleEditSystemModal = toggleState => {
        this.setState(state => ({
            editSystemModalOpen: toggleState
        }));
    }

    handleTogglePreviewSensorDataModal = toggleState => {
        if (!toggleState) {
            this.props.clearSensorData();
        }
        this.setState(state => ({
            previewSensorDataModalOpen: toggleState
        }));
    }

    handleToggleWeatherDataModal = toggleState => {
        if (!toggleState) {
            this.props.clearWeatherData();
        }
        this.setState(state => ({
            weatherDataModalOpen: toggleState
        }));
    }

    renderDataPanel = (selectedNode) => {
        switch (selectedNode.type) {
            case 'site':
                return (
                    <SiteDataInsert
                        selectedNode={selectedNode}
                        onToggleWeatherDataModal={this.handleToggleWeatherDataModal}
                        onToggleCreateLinkModal={this.handleToggleCreateLinkModal}
                        onToggleDeleteLinkModal={this.handleToggleDeleteLinkModal}
                    />
                );
            case 'equipmentItem':
                return (
                    <EquipmentItemDataInsert
                        selectedNode={selectedNode}
                        onToggleDeleteSensorModal={this.handleToggleDeleteSensorModal}
                        onToggleEditSensorModal={this.handleToggleEditSensorModal}
                        onToggleDeleteSystemEntityModal={this.handleToggleDeleteSystemEntityModal}
                        onToggleDeleteLinkModal={this.handleToggleDeleteLinkModal}
                        onTogglePreviewDataModal={this.handleTogglePreviewSensorDataModal}
                        onToggleCreateLinkModal={this.handleToggleCreateLinkModal}
                    />
                );
            case 'systemItem':
                return (
                    <SystemItemDataInsert
                        selectedNode={selectedNode}
                        onToggleDeleteEquipmentEntityModal={this.handleToggleDeleteEquipmentEntityModal}
                        onToggleDeleteSensorModal={this.handleToggleDeleteSensorModal}
                        onToggleEditSensorModal={this.handleToggleEditSensorModal}
                        onTogglePreviewDataModal={this.handleTogglePreviewSensorDataModal}
                    />
                );
            case 'client':
                return (
                    <ClientDataInsert
                        selectedNode={selectedNode}
                        onToggleCreateContactModal={this.handleToggleCreateContactModal}
                        onToggleCreateLinkModal={this.handleToggleCreateClientLinkModal}
                        onToggleDeleteContactModal={this.handleToggleDeleteContactModal}
                        onToggleDeleteLinkModal={this.handleToggleDeleteLinkModal}
                        onToggleEditContactModal={this.handleToggleEditContactModal}
                        onToggleCreateContactLinkModal={this.handleToggleCreateContactLinkModal}
                    />
                );
            default:
                return (
                    <DataPanel
                        selectedNode={selectedNode}
                        onToggleCreateContactModal={this.handleToggleCreateContactModal}
                        onToggleDeleteCampusSiteModal={this.handleToggleDeleteCampusSiteModal}
                        onToggleDeleteContactModal={this.handleToggleDeleteContactModal}
                        onToggleDeleteLinkModal={this.handleToggleDeleteLinkModal}
                        onToggleDeleteEquipmentEntityModal={this.handleToggleDeleteEquipmentEntityModal}
                        onToggleEditContactModal={this.handleToggleEditContactModal}
                    />
                );
        }
    }

    render() {
        const { isTreePanelCollapsed } = this.state;
        const { deviceObjects, selectedNode, selectedSensor, setTargetSite, fetchSensorData } = this.props;
        const dataPanel = this.renderDataPanel(selectedNode);

        const deviceObject = deviceObjects ? deviceObjects.find(d => d.id === selectedSensor.deviceObjectId) : null;
        const pollingInterval = deviceObject ? deviceObject.sampleInterval : 15;

        return (
            <React.Fragment>
                <div className={isTreePanelCollapsed ? clsx(classes.InformationPage, classes.collapsed) : classes.InformationPage}>
                    <React.Fragment>
                        <div className={classes.treePanel}>
                            <TreePanel
                                handleIsTreePanelCollapsed={this.handleIsTreePanelCollapsed}
                                isTreePanelCollapsed={isTreePanelCollapsed}
                                onCreateArea={this.handleToggleCreateAreaModal}
                                onCreateCampus={this.handleToggleCreateCampusModal}
                                onCreateClient={this.handleToggleCreateClientModal}
                                onCreateEquipment={this.handleToggleCreateEquipmentModal}
                                onCreateSite={this.handleToggleCreateSiteModal}
                                onCreateSystem={this.handleToggleCreateSystemModal}
                            />
                        </div>
                        <div className={classes.smallPanelContainer}>
                            <div className={classes.smallPanel}>
                                <InformationPanel
                                    node={selectedNode}
                                />
                            </div>
                            <div className={classes.smallPanel}>
                                <ActionPanel
                                    companyInfo={this.props.companyInfo}
                                    currentScopes={this.props.currentScopes}
                                    node={selectedNode}
                                    setTargetSite={setTargetSite}
                                    onToggleCreateAreaModal={this.handleToggleCreateAreaModal}
                                    onToggleCreateAreaEquipmentModal={this.handleToggleCreateAreaEquipmentModal}
                                    onToggleCreateCampusModal={this.handleToggleCreateCampusModal}
                                    onToggleCreateCampusSitesModal={this.handleToggleCreateCampusSitesModal}
                                    onToggleCreateContactModal={this.handleToggleCreateContactModal}
                                    onToggleCreateEquipmentModal={this.handleToggleCreateEquipmentModal}
                                    onToggleCreateEquipmentAreaModal={this.handleToggleCreateEquipmentAreaModal}
                                    onToggleCreateEquipmentSystemModal={this.handleToggleCreateEquipmentSystemModal}
                                    onToggleCreateSiteModal={this.handleToggleCreateSiteModal}
                                    onToggleCreateSystemModal={this.handleToggleCreateSystemModal}
                                    onToggleCreateSystemEquipmentModal={this.handleToggleCreateSystemEquipmentModal}
                                    onToggleCreateSensorModal={this.handleToggleCreateSensorModal}
                                    onToggleDeleteAreaModal={this.handleToggleDeleteAreaModal}
                                    onToggleDeleteCampusModal={this.handleToggleDeleteCampusModal}
                                    onToggleDeleteClientModal={this.handleToggleDeleteClientModal}
                                    onToggleDeleteEquipmentModal={this.handleToggleDeleteEquipmentModal}
                                    onToggleDeleteSiteModal={this.handleToggleDeleteSiteModal}
                                    onToggleDeleteSystemModal={this.handleToggleDeleteSystemModal}
                                    onToggleEditAreaModal={this.handleToggleEditAreaModal}
                                    onToggleEditCampusModal={this.handleToggleEditCampusModal}
                                    onToggleEditEntityModal={this.handleToggleEditClientModal}
                                    onToggleEditEquipmentModal={this.handleToggleEditEquipmentModal}
                                    onToggleEditSiteModal={this.handleToggleEditSiteModal}
                                    onToggleEditSystemModal={this.handleToggleEditSystemModal}
                                    onTogglePreviewDataModal={this.handleTogglePreviewSensorDataModal}
                                />
                            </div>
                        </div>
                        {dataPanel}
                    </React.Fragment>
                </div>
                <CreateAreaModal
                    open={this.state.createAreaModalOpen}
                    close={() => this.handleToggleCreateAreaModal(false)}
                    title="Create New Area"
                />
                <CreateAreaEquipmentModal
                    open={this.state.createAreaEquipmentOpen}
                    close={() => this.handleToggleCreateAreaEquipmentModal(false)}
                    title="Add Equipment to Area"
                />
                <CreateCampusSitesModal
                    open={this.state.createCampusSitesModalOpen}
                    close={() => this.handleToggleCreateCampusSitesModal(false)}
                    title="Add Sites to Campus"
                />
                <CreateCampusModal
                    open={this.state.createCampusModalOpen}
                    close={() => this.handleToggleCreateCampusModal(false)}
                    title="Create Campus"
                />
                <CreateClientModal
                    open={this.state.createClientModalOpen}
                    close={() => this.handleToggleCreateClientModal(false)}
                    title="Create New Client"
                />
                <CreateContactModal
                    open={this.state.createContactModalOpen}
                    close={() => this.handleToggleCreateContactModal(false)}
                    title="Create New Contact"
                />
                <CreateEquipmentModal
                    open={this.state.createEquipmentModalOpen}
                    close={() => this.handleToggleCreateEquipmentModal(false)}
                    title="Create New Equipment"
                />
                <CreateEquipmentAreaModal
                    open={this.state.createEquipmentAreaModalOpen}
                    close={() => this.handleToggleCreateEquipmentAreaModal(false)}
                    title="Add Equipment to Areas"
                />
                <CreateEquipmentSystemModal
                    open={this.state.createEquipmentSystemModalOpen}
                    close={() => this.handleToggleCreateEquipmentSystemModal(false)}
                    title="Add Equipment to Systems"
                />
                <CreateLinkModal
                    open={this.state.createLinkModalOpen}
                    close={() => this.handleToggleCreateLinkModal(false)}
                    title="New ERP Link"
                    linkType={selectedNode.type}
                />
                <CreateClientLinkModal
                    open={this.state.createClientLinkModalOpen}
                    close={() => this.handleToggleCreateClientLinkModal(false)}
                    title="Create ERP Client Link"
                />
                <CreateContactLinkModal
                    open={this.state.createContactLinkModalOpen}
                    close={() => this.handleToggleCreateContactLinkModal(false)}
                    title="New ERP Link"
                />
                <CreateSensorModal
                    open={this.state.createSensorModalOpen}
                    close={() => this.handleToggleCreateSensorModal(false)}
                    title="Create New Sensor"
                />
                <CreateSiteModal
                    open={this.state.createSiteModalOpen}
                    close={() => this.handleToggleCreateSiteModal(false)}
                    title="Create New Site"
                />
                <CreateSystemModal
                    open={this.state.createSystemModalOpen}
                    close={() => this.handleToggleCreateSystemModal(false)}
                    title="Create New System"
                />
                <CreateSystemEquipmentModal
                    open={this.state.createSystemEquipmentModalOpen}
                    close={() => this.handleToggleCreateSystemEquipmentModal(false)}
                    title="Add Equipment to System"
                />
                <DeleteCampusSiteModal
                    open={this.state.deleteCampusSiteModalOpen}
                    close={() => this.handleToggleDeleteCampusSiteModal(false)}
                    title="Remove Site from Campus"
                />
                <DeleteContactModal
                    open={this.state.deleteContactModalOpen}
                    close={() => this.handleToggleDeleteContactModal(false)}
                    title="Delete Contact"
                />
                <DeleteLinkModal
                    open={this.state.deleteLinkModalOpen}
                    close={() => this.handleToggleDeleteLinkModal(false)}
                    title="Delete Link"
                />
                <DeleteAreaModal
                    open={this.state.deleteAreaModalOpen}
                    close={() => this.handleToggleDeleteAreaModal(false)}
                    title="Delete Area"
                />
                <DeleteCampusModal
                    open={this.state.deleteCampusModalOpen}
                    close={() => this.handleToggleDeleteCampusModal(false)}
                    title="Delete Campus"
                />
                <DeleteClientModal
                    open={this.state.deleteClientModalOpen}
                    close={() => this.handleToggleDeleteClientModal(false)}
                    title="Delete Client"
                />
                <DeleteEquipmentModal
                    open={this.state.deleteEquipmentModalOpen}
                    close={() => this.handleToggleDeleteEquipmentModal(false)}
                    title="Delete Equipment"
                />
                <DeleteSensorModal
                    open={this.state.deleteSensorModalOpen}
                    close={() => this.handleToggleDeleteSensorModal(false)}
                    title="Delete Sensor"
                />
                <DeleteEquipmentEntityModal
                    open={this.state.deleteEquipmentEntityModalOpen}
                    close={() => this.handleToggleDeleteEquipmentEntityModal(false)}
                />
                <DeleteSiteModal
                    open={this.state.deleteSiteModalOpen}
                    close={() => this.handleToggleDeleteSiteModal(false)}
                    title="Delete Site"
                />
                <DeleteSystemModal
                    open={this.state.deleteSystemModalOpen}
                    close={() => this.handleToggleDeleteSystemModal(false)}
                    title="Delete System"
                />
                <DeleteSystemEntityModal
                    open={this.state.deleteSystemEntityModalOpen}
                    close={() => this.handleToggleDeleteSystemEntityModal(false)}
                    title="Disassociate System from Equipment"
                />
                <EditAreaModal
                    open={this.state.editAreaModalOpen}
                    close={() => this.handleToggleEditAreaModal(false)}
                    title="Edit Area"
                />
                <EditCampusModal
                    open={this.state.editCampusModalOpen}
                    close={() => this.handleToggleEditCampusModal(false)}
                    title="Edit Campus"
                />
                <EditClientModal
                    open={this.state.editClientModalOpen}
                    close={() => this.handleToggleEditClientModal(false)}
                    title="Edit Client"
                />
                <EditContactModal
                    open={this.state.editContactModalOpen}
                    close={() => this.handleToggleEditContactModal(false)}
                    title="Edit Contact"
                />
                <EditEquipmentModal
                    open={this.state.editEquipmentModalOpen}
                    close={() => this.handleToggleEditEquipmentModal(false)}
                    title="Edit Equipment"
                />
                <EditSensorModal
                    open={this.state.editSensorModalOpen}
                    close={() => this.handleToggleEditSensorModal(false)}
                    title="Edit Sensor"
                />
                <EditSiteModal
                    open={this.state.editSiteModalOpen}
                    close={() => this.handleToggleEditSiteModal(false)}
                    title="Edit Site"
                />
                <EditSystemModal
                    open={this.state.editSystemModalOpen}
                    close={() => this.handleToggleEditSystemModal(false)}
                    title="Edit System"
                />
                {process.env.sensorDataModalEnabled &&
                    <PreviewSensorDataModal
                        open={this.state.previewSensorDataModalOpen}
                        close={() => this.handleTogglePreviewSensorDataModal(false)}
                        title="Preview Sensor Data"
                        pollingInterval={pollingInterval}
                        selectedSensor={selectedSensor}
                        fetchSensorData={fetchSensorData}
                        history={this.props.history}
                        location={this.props.location}
                    />
                }
                {process.env.weatherDataModalEnabled &&
                    <WeatherDataModal
                        onConfirm={this.handleToggleWeatherDataModal}
                        close={() => this.handleToggleWeatherDataModal(false)}
                        title="Preview Weather Data"
                        open={this.state.weatherDataModalOpen}
                        history={this.props.history}
                        location={this.props.location}
                        selectedNode={this.props.selectedNode}
                    />
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    companyInfo:    state.companyInfo,
    currentScopes:  state.core.currentScopes,
    deviceObjects:  state.device.deviceObjects,
    selectedNode:   state.architect.selectedNode,
    selectedSensor: state.architect.selectedSensor
});

const mapDispatchToProps = {
    ...ArchitectActions,
    ...CoreActions,
    ...LookupActions,
    ...WizardActions,
    clearSensorData,
    fetchErpAgents,
    fetchEquipmentTypesLookup,
    fetchSensorData,
    fetchSensorTypes,
    fetchSystemTypes
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InformationPage));
